import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
// import axios from 'axios'
import jwt_decode from "jwt-decode";
import Dashboard from "../views/Dashboard.vue";
import Loader from "../views/loader.vue";
import Profile from "../views/Profile.vue";
import Mytickets from "../views/Mytickets.vue";
import Notfound from "../views/Notfound.vue";
import login from "../views/user-management/login.vue";
import signup from "../views/user-management/signUp.vue";
import passConf from "../views/user-management/passConf.vue";
import Pwdrecovery from "../views/user-management/passwordRecap.vue";
import Geomap from "../views/Geomap.vue";
import Availableroutes from "../views/Availableroutes.vue";
import ContactUs from "../views/Contactus.vue";
import companyDetailsRegistration from "../views/CompanyRegistration/companyDetails.vue";
import AdminDashboard from "../views/companyAdmin/adminDashboard.vue";
import adminTransactions from "../views/companyAdmin/adminTransactions.vue";
import adminBranches from "../views/companyAdmin/adminBranches.vue";
import adminBuses from "../views/companyAdmin/adminBuses.vue";
import adminRoutes from "../views/companyAdmin/Routes.vue";
import adminWorkers from "../views/companyAdmin/Workers.vue";
import adminSupport from "../views/companyAdmin/adminSupport.vue";
import companyProfile from "../views/companyAdmin/profileCompany.vue";
import adminProfile from "../views/companyAdmin/adminProfile.vue";
import companyShalois from "../views/companyAdmin/WorkersComponent/shalois.vue";
import companyDrivers from "../views/companyAdmin/WorkersComponent/drivers.vue";
import companyProviders from "../views/companyAdmin/WorkersComponent/providers.vue";
import adminTodayTransactions from "../views/companyAdmin/Transactions/today.vue";
import adminOtherTransactions from "../views/companyAdmin/Transactions/others.vue";
import shaloiTodayTransactions from "../views/Shaloi/Transactions/today.vue";
import shaloiOtherTransactions from "../views/Shaloi/Transactions/others.vue";
import companyRoutes from "../views/companyAdmin/RoutesComponents/routes.vue";
import companyBreakPoints from "../views/companyAdmin/RoutesComponents/breakpoints.vue";
import ResetByPhone from "../views/user-management/phoneCodeConfirm.vue";
import PhoneNumberVerification from "../views/user-management/accountVerification.vue";
import Bus from "../components/Dashboard/TransportMeans/Bus.vue";
import Taxi from "../components/Dashboard/TransportMeans/Taxi.vue";
import Plane from "../components/Dashboard/TransportMeans/Plane.vue";
import Ship from "../components/Dashboard/TransportMeans/Ship.vue";
import CompanyInfo from "../views/CompanyRegistration/companyInfo.vue";
import TaxiMytickets from "../views/TaxiMytickets.vue";
import MotoMytickets from "../views/MotoMytickets.vue";
import Search from "../views/Search.vue";
import BusSearch from "../components/Dashboard/Search/BusSearch.vue";
import TaxiSearch from "../components/Dashboard/Search/TaxiSearch.vue";
import PlaneSearch from "../components/Dashboard/Search/PlaneSearch.vue";
import ShipSearch from "../components/Dashboard/Search/ShipSearch.vue";
import MotorSearch from "../components/Dashboard/Search/MotorSearch.vue";
import BusRoutes from "../components/Dashboard/AvailableRoutes/BusRoutes.vue";
import TaxiRoutes from "../components/Dashboard/AvailableRoutes/TaxiRoutes.vue";
import PlaneRoutes from "../components/Dashboard/AvailableRoutes/PlaneRoutes.vue";
import ShipRoutes from "../components/Dashboard/AvailableRoutes/ShipRoutes.vue";
import MotorRoutes from "../components/Dashboard/AvailableRoutes/MotorRoutes.vue";
import LandingPage from "../views/LandingPage.vue";
import Notifications from "../views/Notifications.vue";
import FavouriteCompanyTickets from "../views/FavouriteCompanyTickets.vue";
import FavouriteFilters from "../components/Dashboard/FavouriteFilters/FavouritesCompanyFilters.vue";
import BusFavouriteFilters from "../components/Dashboard/FavouriteFilters/BusFavouriteFilters.vue";
// shaloi components
import shaloiDashboard from "../views/Shaloi/shaloiDashboard.vue";
import ShaloiTransactions from "../views/Shaloi/shaloiTransactions.vue";
import ShaloiSupport from "../views/Shaloi/shaloiSupport.vue";
import shaloiProfile from "../views/Shaloi/shaloiProfile.vue";
import shaloiNoBranch from "../views/Shaloi/NoBranch.vue";
import busesScheduledForToday from "../views/Shaloi/components/todaySchedules.vue";
import busesScheduledForFuture from "../views/Shaloi/components/futureSchedules.vue";
// Developers components
import adminRegistration from "../views/Developers/companyAdminRegister.vue";
//Ticket provider components
import ProviderDashboard from "../views/TicketProvider/ProviderDashboard.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: login,
    meta: {
      guest: true,
    },
  },
  {
    path: "/loader",
    name: "laoder",
    component: Loader,
    meta: {
      guest: true,
    },
  },

  {
    path: "/signup",
    name: "signup",
    component: signup,
    meta: {
      guest: true,
    },
  },
  {
    path: "/",
    name: "landing page",
    component: LandingPage,
    meta: {
      guest: true,
    },
  },

  {
    path: "/pwdreset",
    name: "pwdreset",
    component: passConf,
    meta: {
      guest: true,
    },
  },

  {
    path: "/admin",
    redirect: "/admin/dashboard",
  },
  {
    path: "/phoneNumberVerification",
    name: "phoneNumberVerification",
    component: PhoneNumberVerification,
    meta: {
      guest: true,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    props(route) {
      return { ticket: route.query.ticket };
    },
    children: [
      {
        path: "/dashboard/bus",
        name: "Bus",
        component: Bus,
      },
      {
        path: "/dashboard/taxi",
        name: "Taxi",
        component: Taxi,
      },
      {
        path: "/dashboard/plane",
        name: "Plane",
        component: Plane,
      },
      {
        path: "/dashboard/ship",
        name: "Ship",
        component: Ship,
      },
      {
        path: "",
        redirect: "/dashboard/bus",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/pwdrecovery",
    name: "pwdrecovery",
    component: Pwdrecovery,
    meta: {
      guest: true,
    },
  },

  {
    path: "/myTickets/bus",
    name: "Mytickets",
    component: Mytickets,
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/myTickets/taxi",
    name: "TaxiMytickets",
    component: TaxiMytickets,
    meta: {
      // requireAuth: true,
      guest: true,
    },
  },

  {
    path: "/myTickets/moto",
    name: "MotoMytickets",
    component: MotoMytickets,
    meta: {
      // requireAuth: true,
      guest: true,
    },
  },

  {
    path: "/myTickets",
    redirect: "/myTickets/bus",
  },

  {
    path: "/routes",
    name: "Availableroutes",
    component: Availableroutes,
    children: [
      {
        path: "/routes/bus",
        name: "BusRoutes",
        component: BusRoutes,
      },
      {
        path: "/routes/taxi",
        name: "TaxiRoutes",
        component: TaxiRoutes,
      },
      {
        path: "/routes/plane",
        name: "PlaneRoutes",
        component: PlaneRoutes,
      },
      {
        path: "/routes/ship",
        name: "ShipRoutes",
        component: ShipRoutes,
      },
      {
        path: "/routes/motor",
        name: "MotorRoutes",
        component: MotorRoutes,
      },
      {
        path: "",
        redirect: "/routes/bus",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/geoMap",
    name: "Geomap",
    component: Geomap,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/contactUs",
    name: "ContactUs",
    component: ContactUs,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/search",
    name: "Search",
    component: Search,
    children: [
      {
        path: "/search/bus",
        name: "BusSearch",
        component: BusSearch,
      },
      {
        path: "/search/taxi",
        name: "TaxiSearch",
        component: TaxiSearch,
      },
      {
        path: "/search/plane",
        name: "PlaneSearch",
        component: PlaneSearch,
      },
      {
        path: "/search/ship",
        name: "ShipSearch",
        component: ShipSearch,
      },
      {
        path: "/search/motor",
        name: "MotorSearch",
        component: MotorSearch,
      },
      {
        path: "",
        redirect: "/search/bus",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/favourites",
    name: "FavouriteCompanyTickets",
    component: FavouriteCompanyTickets,
    props(route) {
      return { company: route.query.company };
    },
    children: [
      {
        path: "/favourites/bus",
        name: "BusFavouriteFilters",
        component: BusFavouriteFilters,
      },
      {
        path: "",
        redirect: "/dashboard",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/companyDetailsRegistration",
    name: "companyDetailsRegistration",
    component: companyDetailsRegistration,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/resetByPhone",
    name: "pwdResetByPhone",
    component: ResetByPhone,
    meta: {
      guest: true,
    },
  },
  {
    path: "/admin/transactions",
    name: "AdminTransactions",
    component: adminTransactions,
    children: [
      {
        path: "/admin/todayTransactions",
        name: "adminTodayTransactions",
        component: adminTodayTransactions,
        // meta: {
        //   requireAuth: true,
        // },
      },
      {
        path: "/admin/otherTransactions",
        name: "adminOtherTransactions",
        component: adminOtherTransactions,
        // meta: {
        //   requireAuth: true,
        // },
      },
      {
        path: "",
        redirect: "/admin/todayTransactions",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/branches",
    name: "AdminBranches",
    component: adminBranches,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/Routes",
    name: "AdminRoutes",
    component: adminRoutes,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/buses",
    name: "AdminBuses",
    component: adminBuses,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/workers",
    name: "AdminWorkers",
    component: adminWorkers,
    children: [
      {
        path: "/admin/shalois",
        name: "CompanyShalois",
        component: companyShalois,
      },
      {
        path: "/admin/drivers",
        name: "CompanyDrivers",
        component: companyDrivers,
      },
      {
        path: "/admin/providers",
        name: "CompanyProviders",
        component: companyProviders,
      },
      {
        path: "",
        redirect: "/admin/drivers",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/routes",
    name: "AdminRoutes",
    component: adminRoutes,
    children: [
      {
        path: "/admin/croutes",
        name: "CompanyRoutes",
        component: companyRoutes,
      },
      {
        path: "/admin/cbreakpoints",
        name: "CompanyBreakpoints",
        component: companyBreakPoints,
      },
      {
        path: "",
        redirect: "/admin/croutes",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/support",
    name: "AdminSupport",
    component: adminSupport,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/developer/adminRegistration",
    name: "AdminRegistration",
    component: adminRegistration,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/companyReg",
    name: "companyInfo",
    component: CompanyInfo,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/companyProfile",
    name: "companyProfile",
    component: companyProfile,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/admin/profile",
    name: "adminProfile",
    component: adminProfile,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/shaloi/profile",
    name: "shaloiProfile",
    component: shaloiProfile,
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/shaloi/dashboard",
    name: "shaloiDashboard",
    component: shaloiDashboard,
    children: [
      {
        path: "/shaloi/futureSchedules",
        name: "shaloiBusSchedulesForFuture",
        component: busesScheduledForFuture,
      },
      {
        path: "/shaloi/todaySchedules",
        name: "shaloiBusSchedulesFortoday",
        component: busesScheduledForToday,
      },
      {
        path: "",
        redirect: "/shaloi/todaySchedules",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/shaloi/support",
    name: "ShaloiSupport",
    component: ShaloiSupport,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/shaloi/NoBranch",
    name: "ShaloiNoBranch",
    component: shaloiNoBranch,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/shaloi/transactions",
    name: "ShaloiTransactions",
    component: ShaloiTransactions,
    children: [
      {
        path: "/shaloi/todayTransactions",
        name: "shaloiTodayTransactions",
        component: shaloiTodayTransactions,
        meta: {
          requireAuth: true,
        },
      },
      {
        path: "/shaloi/otherTransactions",
        name: "shaloiOtherTransactions",
        component: shaloiOtherTransactions,
        meta: {
          requireAuth: true,
        },
      },
      
      {
        path: "",
        redirect: "/shaloi/todayTransactions",
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/provider",
    name: "ProviderDashboard",
    component: ProviderDashboard,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/shaloi",
    redirect: "/shaloi/dashboard",
  },

  // {
  //   path: '/about',
  //   name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }

  {
    path: "/:pathMatch(.*)*",
    name: "Notfound",
    component: Notfound,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (localStorage.getItem("jwt") == null) {
      next({
        path: "/",
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else if (to.meta.guest) {
    if (localStorage.getItem("jwt") == null) {
      next();
    } else {
      const token: any = localStorage.getItem("jwt");
      const decoded: any = jwt_decode(token);
      const userRole = decoded.role;
      if (userRole == "admin") {
        next("/admin/dashboard");
      } else if (userRole == "developer") {
        next("/developer/adminRegistration");
      } else if (userRole == "shaloi") {
        next("/shaloi/dashboard");
      } else if (userRole == "provider") {
        next("/provider");
      } else {
        next("/dashboard");
      }
    }
  } else {
    next();
  }
});

export default router;
